import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig} from '@angular/material/legacy-snack-bar';
import {environment} from '@env/environment';

@Component({
    selector: 'ngc-recovery-codes',
    templateUrl: './recovery-codes.component.html',
    styleUrls: ['./recovery-codes.component.scss']
})
export class RecoveryCodesComponent implements OnInit {

    @Input() recoveryCodes: string[];
    @Input() recoveryCodesHaveToBeSaved: boolean;

    @Output() closeRecoveryCodes = new EventEmitter<void>();
    @Output() download = new EventEmitter<void>();

    isPrinting: boolean;
    recoveryCodesWereSavedByUser: boolean;
    readonly customer = environment.customer.customerShortName;

    constructor(public snackBar: MatSnackBar) {
    }

    ngOnInit(): void {
    }

    onCloseRecoveryCodes() {
        this.closeRecoveryCodes.emit();
    }

    onDownload() {
        this.download.emit();
        this.recoveryCodesWereSavedByUser = true;
    }

    onPrint() {
        this.isPrinting = true;
        setTimeout(() => {
            this.isPrinting = false;
            const printData = document.getElementById('data-to-print').cloneNode(true);
            document.body.appendChild(printData);
            window.print();
            document.body.removeChild(printData);
            this.recoveryCodesWereSavedByUser = true;
        }, 0);
    }

    onCopyToClipboard() {
        this.snackBar.open('Copied to Clipboard' , '', <MatSnackBarConfig>{duration: 1500});
        this.recoveryCodesWereSavedByUser = true;
    }
}
